import { render } from "./TitlePage.vue?vue&type=template&id=651be052&scoped=true"
import script from "./TitlePage.vue?vue&type=script&lang=js"
export * from "./TitlePage.vue?vue&type=script&lang=js"

import "./TitlePage.vue?vue&type=style&index=0&id=651be052&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/endless-projects/speedway/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651be052"]])

export default __exports__